export const isStaffConnectedToService = (service, staffMember) => {
  if (!service || !staffMember || staffMember.active === false) return false;
  const serviceStaffIds = Array.isArray(service.staff_ids) ? service.staff_ids : [];
  const staffServiceIds = Array.isArray(staffMember.service_ids) ? staffMember.service_ids : [];
  return serviceStaffIds.includes(staffMember.id) || staffServiceIds.includes(service.id);
};

export const getConnectedActiveStaff = (service, staffMembers) => (
  (staffMembers || []).filter((staffMember) => isStaffConnectedToService(service, staffMember))
);

export const isServiceBookable = (service, staffMembers) => (
  getConnectedActiveStaff(service, staffMembers).length > 0
);